import React from 'react'
import PropTypes from 'prop-types'
import { EditAthletesForm } from 'local/components'

const AthletesAddComponent = ({ onSubmit }) => (
  <EditAthletesForm
    header="Add Athlete"
    onSubmit={onSubmit}
    initialValues={{}}
  />
)

AthletesAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default AthletesAddComponent
